<template>
   <v-layout align-center justify-center class="upload_bg">
        <p v-if="error" style="color:red;">{{ errorMessage }}</p> 
        <v-toolbar fixed flat class="transparent" style="color:white;">
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn dark flat @click="closeDialog">Close</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm7>  
                <p v-if="error" style="color:red;">{{ errorMessage }}</p> 
                <v-alert :value="networkError" type="warning" dismissible>
                    Save Picture failed due to network error. Please check your internet connection then retry again.
                </v-alert>
                <div class="text-xs-center" style="padding:20px;">
                    <vue-dropzone ref="myVueDropzone" 
                        style="height:200px;"
                        id="dropzone" 
                        v-show="showUpload"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="uploadSuccess"
                        v-on:vdropzone-file-added="fileAdded"
                        ></vue-dropzone>
                </div>
            </v-flex> 
        </v-layout>
</template>
<script>
    
import axios from 'axios'
import companyApi from '@/api/company'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import pageKeys from '@/common/pagekeys'

export default {
    name: 'edit-team',
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            userId: 0,
            loading: false,   
            img: null,
            video: null,      
            showUpload: true,      
            dropzoneOptions: {                    
                url: `${axios.defaults.baseURL}Image/upload/company_logo`,
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "page_key": pageKeys.company_account,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                addRemoveLinks: true,
                dictDefaultMessage: "<br><b class='subheading'><u>Drop your photo here or click to browse gallery</u><b><br><br><p class='subheading'>Maximum 250 KB</p>",
                maxFiles: 1,
                acceptedFiles: 'image/*', 
                maxFilesize: 0.25,   //250kb
            },
            networkError: false,
            uploading: false,
            error: false,
            errorMessage: '', 
            companyId: null
        }
    },
    methods: {
        fileAdded(file) {
            this.loading = true
        },
        async uploadSuccess(file, response) {
            console.log('uploadSuccess')
            console.log(response)
            
            this.error = false
            try{
                var fileName = response.fileName
                const data = {"logoFileName": fileName}
                const result = await companyApi.update(data);

                if (result && result.status == 200) {
                    this.$store.commit('setCompanyLogo', fileName) //update store 
                    this.$root.$emit('updateHeaderCompanyLogo','updateHeaderCompanyLogoHandler')
                    this.$refs.myVueDropzone.removeAllFiles()
                    this.$emit('send', null)
                    this.$emit('update:dialogEditLogo', false)
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading = false
            }
        },
        closeDialog() {
            this.showUpload=true
            this.$emit('update:dialogEditLogo', false)   
            this.networkError = false
        }
    },        
    created() {
        this.companyId = this.$store.state.companyId
    }
}
</script>
<style scoped>
.upload_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
 }
</style>